// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auto-margin{margin:auto}.pl-name{font-weight:bold}.last-gk-skill{margin-left:-31px}.skills-section{border-radius:5%;border:2px solid #28a745;margin-bottom:5px}", ""]);
// Exports
module.exports = exports;
